import { FuturesMarginType } from '@kwenta/sdk/types'

export const PERPS_VERSIONS_ENABLED = process.env.NEXT_PUBLIC_PERPS_VERSIONS_ENABLED ?? 'both' // v2 | v3 | both

export const SMART_MARGIN_ENABLED =
	PERPS_VERSIONS_ENABLED === 'v2' || PERPS_VERSIONS_ENABLED === 'both'
export const CROSS_MARGIN_ENABLED =
	PERPS_VERSIONS_ENABLED === 'v3' || PERPS_VERSIONS_ENABLED === 'both'

export const DEFAULT_FUTURES_MARGIN_TYPE = CROSS_MARGIN_ENABLED
	? FuturesMarginType.CROSS_MARGIN
	: FuturesMarginType.SMART_MARGIN
